import { useTranslation } from "react-i18next";
import { AnchorLink } from "../AnchorLink/AnchorLink";
import { getImage } from "../../services/ImageService";

export function SolutionPageSelection() {
    const { t } = useTranslation();

    return (
        <div className="group flex items-center items-center cursor-pointer select-none h-full">
            <div className="text-base font-bold text-pine w-full h-full flex gap-2 items-center z-20 gap-3 h-[50px] rounded-full group-hover:bg-[rgba(36,45,41,0.05)] md:px-12">
                <div style={{ textWrap: "nowrap" }}>{t("solutions")}</div>
                {/* tailwind text-nowrap isn't working, but inline style is */}
                <div className="w-4 mt-1">
                    <img
                        src={getImage("gui/menu-down-pine.svg")}
                        className="w-full"
                    />
                </div>
            </div>
            <div className="hidden group-hover:flex absolute flex-col bg-white top-32 z-10 w-max select-none overflow-y-auto shadow-2xl rounded-3xl">
                <AnchorLink
                    content={t("timber-purchases")}
                    target="/#timber-purchases"
                />
                <AnchorLink
                    content={t("home-final-felling-drone-praxis-card-title")}
                    target="/final-felling-drone-praxis"
                    className="pl-24"
                />
                <AnchorLink
                    content={t("forest-management")}
                    target="/#forest-management"
                />
                <AnchorLink
                    content={t("home-planning-drone-praxis-card-title")}
                    target="/planning-drone-praxis"
                    className="pl-24"
                />
                <AnchorLink
                    content={t("damage-inventory")}
                    target="/#damage-inventory"
                />

                <AnchorLink
                    content={t("home-bark-beetle-card-title")}
                    target="/bark-beetle"
                    className="pl-24"
                />
                <AnchorLink
                    content={t("home-windthrow-card-title")}
                    target="/windthrow"
                    className="pl-24"
                />
                <AnchorLink
                    content={t(
                        "home-wildfires-and-prescribed-burning-card-title",
                    )}
                    target="/fire"
                    className="pl-24"
                />
                <AnchorLink
                    content={t("forest-owner-relations")}
                    target="/#forest-owner-relations"
                />
                <AnchorLink
                    content={t("home-wildlife-card-title")}
                    target="/wildlife"
                />
            </div>
        </div>
    );
}
